import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { ChatInterface } from './ChatInterface';
import { Menu, X } from 'lucide-react';

export const Layout = ({ user, onLogout, onPasswordChanged }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeChatId, setActiveChatId] = useState(null);
  const [activeChatData, setActiveChatData] = useState(null);
  const location = useLocation();

  const handleSelectChat = (chat) => {
    setActiveChatId(chat.id);
    setActiveChatData(chat);
  };

  const handleNewChat = () => {
    setActiveChatId(null);
    setActiveChatData(null);
  };

  const isHomePage = location.pathname === '/';

  return (
    <div className="flex h-screen overflow-hidden bg-gray-100 dark:bg-gray-950">
      {/* Mobile sidebar backdrop */}
      <div
        className={`fixed inset-0 bg-black z-40 lg:hidden transition-opacity duration-300 ${
          sidebarOpen ? 'opacity-50 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
        onClick={() => setSidebarOpen(false)}
        aria-hidden="true"
      />

      {/* Sidebar */}
      <aside
        className={`
          fixed lg:static inset-y-0 left-0 z-50
          w-72 transform transition-transform duration-300 ease-in-out
          lg:translate-x-0
          ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}
        `}
      >
        <Sidebar 
          user={user} 
          onCloseMobile={() => setSidebarOpen(false)}
          activeChatId={activeChatId}
          onSelectChat={handleSelectChat}
          onNewChat={handleNewChat}
        />
      </aside>

      {/* Main content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header */}
        <Header user={user} onLogout={onLogout} onPasswordChanged={onPasswordChanged} />

        {/* Mobile menu button */}
        <button
          type="button"
          className="fixed bottom-4 right-4 lg:hidden z-[9999] h-12 w-12 rounded-full shadow-lg bg-blue-600 text-white hover:bg-blue-700 flex items-center justify-center"
          onClick={() => setSidebarOpen(!sidebarOpen)}
          aria-label="Menü umschalten"
        >
          <Menu 
            className="h-6 w-6 absolute transition-opacity duration-200" 
            style={{ opacity: sidebarOpen ? 0 : 1 }}
          />
          <X 
            className="h-6 w-6 absolute transition-opacity duration-200" 
            style={{ opacity: sidebarOpen ? 1 : 0 }}
          />
        </button>

        {/* Page content */}
        <main className="flex-1 overflow-y-auto">
          {isHomePage ? (
            <ChatInterface 
              user={user} 
              chatId={activeChatId} 
              chatData={activeChatData}
            />
          ) : (
            <Outlet />
          )}
        </main>
      </div>
    </div>
  );
};
